import script from "./ReportAppendix_RightModify.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportAppendix_RightModify.vue?vue&type=script&setup=true&lang=js"

import "./ReportAppendix_RightModify.vue?vue&type=style&index=0&id=167c19a5&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-167c19a5"]])

export default __exports__